import Model from "~~/package/mapper/Model";
import {createModel} from "~~/package/utils/ModelUtil";
import {
    AssessmentKnowledgeSummarySkillModel
} from "~~/package/mapper/assessment/model/AssessmentKnowledgeSummarySkillModel";

export class AssessmentKnowledgeSummaryModel extends Model {
    constructor(
        public courseId: number = 0,
        public courseTitle: string = "",
        public passTaskCount: number = 0,
        public totalTaskCount: number = 0,
        public skillSimpleVOList: AssessmentKnowledgeSummarySkillModel[] = []
    ) {
        super();
    }

    public static create(model: Partial<AssessmentKnowledgeSummaryModel>): AssessmentKnowledgeSummaryModel {
        return createModel<AssessmentKnowledgeSummaryModel>(AssessmentKnowledgeSummaryModel, {
            ...model
        });
    }
}